<template>
    <div class="cigo-color-picker"></div>
</template>

<script lang="ts">
import cigoLayer from "@/components/cigo-layer";
import box from "@/components/cigo-ui/unit/other/color-picker/types/box.vue";
import { debounce } from "lodash";
import {
    defineComponent,
    onMounted,
    onUnmounted,
    ref,
    toRef,
    watch
} from "vue";
export default defineComponent({
    name: "CigoColorPicker",
    props: {
        type: {
            type: String,
            default: "box"
        },
        targetElem: {
            type: Object,
            default: {}
        },
        color: {
            //TODO 处理默认颜色值显示
            type: String,
            default: "#000000"
        },
        showOpacity: {
            type: Boolean,
            default: true
        },
        modelSwitch: {
            type: Boolean,
            default: true
        },
        getPopupContainer: {
            type: Function,
            default: () => {
                return null;
            }
        }
    },
    setup(props, ctx) {
        const targetElemRef = toRef(props, "targetElem");
        let layerIndex = -1;
        let scrollTopOnShow = 0;
        let scrollLeftOnShow = 0;
        let showXOnShow = 0;
        let showYOnShow = 0;
        let showX = ref(0);
        let showY = ref(0);
        const show = (evt: any) => {
            if (popupContainer) {
                let target = popupContainer.value.scrollingElement
                    ? popupContainer.value.scrollingElement
                    : popupContainer.value;

                scrollTopOnShow = target.scrollTop;
                scrollLeftOnShow = target.scrollLeft;
            }

            showXOnShow = evt.clientX - evt.offsetX;
            showX.value = evt.clientX - evt.offsetX;
            showYOnShow = evt.clientY - evt.offsetY + 43;
            showY.value = evt.clientY - evt.offsetY + 43;

            const cmpInfo = getComponentInfo();
            layerIndex = cigoLayer.component({
                component: cmpInfo.component,
                width: cmpInfo.width,
                height: cmpInfo.height,
                canDrag: false,
                showX: showX,
                showY: showY,
                maskClose: true,
                showMask: false,
                showCtrlBar: false,
                layerData: {
                    showOpacity: props.showOpacity,
                    modelSwitch: props.modelSwitch
                },
                notify: notify
            });
        };
        const getComponentInfo = () => {
            let info = null;
            switch (props.type) {
                case "box":
                default:
                    info = {
                        component: box,
                        width: "325px",
                        height: props.showOpacity ? "268px" : "244px"
                    };
                    break;
            }
            return info;
        };
        const notify = (flag: string, data: any) => {
            switch (flag) {
                case "change":
                    ctx.emit("update:color", data);
                    ctx.emit("change", data);
                    break;
            }
        };

        let popupContainer: any = null;
        onMounted(() => {
            popupContainer = props.getPopupContainer();
            if (!popupContainer) {
                popupContainer = ref(document);
            }
            //Tips_Flag 动态为标记ref属性的Element绑定事件
            popupContainer.value.addEventListener(
                "scroll",
                onPopupContainerScroll
            );
        });
        onUnmounted(() => {
            popupContainer.value.removeEventListener(
                "scroll",
                onPopupContainerScroll
            );
        });

        const onPopupContainerScroll = (event: any) => {
            let target = event.target.scrollingElement
                ? event.target.scrollingElement
                : event.target;

            showY.value = showYOnShow + scrollTopOnShow - target.scrollTop;
            showX.value = showXOnShow + scrollLeftOnShow - target.scrollLeft;
        };

        const close = (evt: any) => {
            cigoLayer.close(layerIndex);
        };

        return {
            show,
            close
        };
    }
});
</script>

<style lang="scss">
.cigo-color-picker {
    display: none;
}
</style>
